import React from "react";
import { createUseStyles } from "react-jss";
import { Rnd } from "react-rnd";

import { NotesIcon } from "../icons/notes";
import { ResizeHandleIcon } from "../icons/resize_handle";
import { XCloseIcon } from "../icons/x_close";

const useStyles = createUseStyles({
  panel: {
    margin: "20px",
    overflow: "hidden",
    zIndex: 100,
    "& h2": {
      borderBottom: "1px solid var(--black-tint-40)",
    },
  },
  content: {
    // The background color needs to be on the content, not the parent
    // otherwise Chrome will not correctly adjust the scrollbar color
    backgroundColor: "rgba(1, 1, 1, 0.8)",
    // Height of header needs to be deducted to fix overflow
    height: "calc(100% - 36px)",
    overflowY: "scroll",
  },
  header: {
    display: "flex",
    alignItems: "center",
  },
  title: {
    verticalAlign: "middle",
  },
  closeIcon: {
    cursor: "pointer",
    marginLeft: "auto",
    marginRight: "8px",
    height: "16px",
  },
  resizeIcon: {
    position: "absolute",
    bottom: "6px",
    right: "2px",
  },
});

const DraggableResizablePanel = ({
  initialWidth = 250,
  initialHeight = 400,
  initialX = 230,
  initialY = 10,
  maxWidth = undefined,
  maxHeight = undefined,
  minWidth = 300,
  minHeight = 300,
  children,
  title = "Details",
  onClose,
  ...rest
}) => {
  const css = useStyles(rest);

  return (
    <Rnd
      className={css.panel}
      style={{ height: initialHeight, width: initialWidth }}
      default={{
        x: initialX,
        y: initialY,
        width: initialWidth,
        height: initialHeight,
      }}
      bounds="body"
      maxHeight={maxHeight}
      maxWidth={maxWidth}
      minHeight={minHeight}
      minWidth={minWidth}
      {...rest}
    >
      <header className={`flex bg-blue-shade-20 p2 ${css.header}`}>
        <NotesIcon color="white" className="ml2 mr3" />
        <h1 className={`self-center body-xs bold text-white m0 ${css.title}`}>
          {title}
        </h1>
        <span onClick={onClose} className={css.closeIcon}>
          <XCloseIcon size="lg" color="white" />
        </span>
      </header>
      <div className={css.content}>{children}</div>
      <ResizeHandleIcon className={css.resizeIcon} />
    </Rnd>
  );
};

export { DraggableResizablePanel };
